import { render } from "./Fttzs.vue?vue&type=template&id=6528ea10&scoped=true"
import script from "./Fttzs.vue?vue&type=script&lang=js"
export * from "./Fttzs.vue?vue&type=script&lang=js"

import "./Fttzs.vue?vue&type=style&index=0&id=6528ea10&scoped=true&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6528ea10"]])

export default __exports__